// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__EqaZW","children":"Modal_children__KaRBQ","credits":"Modal_credits__Oikrb"};